import React, { FC } from 'react'

// Components
import { Card, CardContent } from '../../ui/card'
import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip'
import { IconCreditCard } from '../../icons/IconCreditCard'
import { IconBank } from '../../icons/IconBank'
import { IconClock2 } from '../../icons/IconClock2'
import { IconBanknotes } from '../../icons/IconBanknotes'
import { IconCheckBook } from '../../icons/IconCheckBook'

// Types
import { IPaymentMethodOptions } from '../../../types/payment'

// Utils
import { cn } from '../../../lib/utils'

interface PaymentMethodItemProps {
  type: IPaymentMethodOptions
  selectedPaymentMethod: IPaymentMethodOptions | null
  title: string
  disabled?: boolean
  onClick: () => void
}

export const PaymentMethodItem: FC<PaymentMethodItemProps> = ({
  type,
  title,
  onClick,
  selectedPaymentMethod,
  disabled,
}) => {
  const iconClassName = cn(
    'w-full h-full max-w-[22px] max-h-[18px] fill-black',
    type === selectedPaymentMethod && 'fill-SeabiscuitMainThemeColor',
    disabled ? 'opacity-40' : 'group-hover:fill-SeabiscuitMainThemeColor transition-all'
  )

  return (
    <Card className="w-full sm:w-[49%] rounded-lg shadow-none border-none">
      <Tooltip>
        <TooltipTrigger asChild>
          <CardContent
            className={cn(
              'p-6 group h-full rounded-lg border border-SeabiscuitDark200ThemeColor/20',
              type === selectedPaymentMethod &&
                'bg-SeabiscuitMainThemeColor/5 text-SeabiscuitMainThemeColor border-SeabiscuitMainThemeColor/5',
              disabled
                ? 'cursor-default bg-[#F8F8F8] text-black/40'
                : 'cursor-pointer hover:bg-SeabiscuitMainThemeColor/5 hover:text-SeabiscuitMainThemeColor hover:border-SeabiscuitMainThemeColor/5 transition-all'
            )}
            onClick={() => !disabled && onClick()}
          >
            <div className="flex items-center gap-2">
              {type === 'credit-card' && <IconCreditCard className={iconClassName} />}
              {type === 'ach' && (
                <>
                  <IconCreditCard className={iconClassName} />
                  <IconBank className={iconClassName} />
                </>
              )}
              {type === 'delayed' && (
                <>
                  <IconCreditCard className={iconClassName} />
                  <IconClock2 className={iconClassName} />
                </>
              )}
              {type === 'cash' && (
                <>
                  <IconBanknotes className={iconClassName} />
                  <IconCheckBook className={iconClassName} />
                </>
              )}
            </div>
            <p className="mt-3 text-sm pointer-events-none">{title}</p>
          </CardContent>
        </TooltipTrigger>
        <TooltipContent className={cn(!disabled && 'opacity-0')}>
          <CardContent className="p-1">
            <p className="tex-sm">Unavailable for this show</p>
          </CardContent>
        </TooltipContent>
      </Tooltip>
    </Card>
  )
}
